import { JobsTabs } from "@components/job_search/jobs_tabs.tsx";
import { TabSearchHeader } from "@components/job_search/tab_search_header.tsx";
import { Body, SectionHeader } from "@sprout/typography.tsx";
import Fingerprint2 from "@images/fingerprint_2.svg";
import useTranslation from "@hooks/use_translation.ts";
import { type RecentSearch } from "@/types/job_search/recent_searches";

export type SavedTabProps = {
  recentSearches: RecentSearch[];
};

export const SavedTab = ({ recentSearches }: SavedTabProps) => {
  const { t } = useTranslation("jobSearch");

  return (
    <>
      <TabSearchHeader recentSearches={recentSearches} />
      <JobsTabs active="saved" savedJobsEnabled />
      <div className="w-full max-w-[1550px] mx-auto px-6 pb-8">
        <div
          className="flex flex-col items-center gap-6 px-6 py-12 text-center bg-white rounded-lg"
          data-provides="saved-jobs-empty-state"
        >
          <img src={Fingerprint2} alt="" width="300" />
          <div className="flex flex-col gap-1">
            <SectionHeader as="h2" className="!pt-0">
              {t("savedJobs.emptyTitle")}
            </SectionHeader>
            <Body className="!text-sm">{t("savedJobs.emptyMessage")}</Body>
          </div>
        </div>
      </div>
    </>
  );
};
